import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  downloadCroqui,
  showUpdate,
  remove,
  showSAP,
  getList,
  alteraMonitora,
  setPaginaAtual,
  toggleControladorStatus,
} from './controladorActions';
import SPButton from '../common/form/spButton';
import configLocal from '../configuracao/configLocal';

import ReactTableGT2A from '../common/grid/gridReactTable';
import PremiumTableShell from '../common/grid/premiumTableShell';
import swal from 'sweetalert2';
import { Button } from 'react-bootstrap';
import { toastr } from 'react-redux-toastr';
import PermissaoUsuario from '../auth/permissao';
import ButtonTooltip from '../common/form/buttonTooltip';
import ToggleSwitch from '../common/form/ToggleSwitch';
import './controladorList.css';

class ControladorList extends Component {
  constructor(props) {
    super(props);

    this.intervalGetList = 0;

    this.removerControlador = this.removerControlador.bind(this);
  }

  handlePageChange = page => {
    this.props.setPaginaAtual(page);
  };

  removerControlador(data) {
    swal({
      title: 'Deseja realmente excluir?',
      text: `Controlador ${data.numero_controlador} será removido permanentemente`,
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Sim, excluir',
      cancelButtonText: 'Cancelar',
      allowOutsideClick: false,
    }).then(result => {
      if (result.value) {
        this.props.remove(data);
      }
    });
  }

  inativarControlador = data => {
    const isOnline = data.ativo === 1;
    const acao = isOnline ? 'colocar offline' : 'colocar online';
    const novoStatus = isOnline ? -1 : 1; // -1 = offline, 1 = online

    swal({
      title: `Deseja ${acao} este controlador?`,
      text: `Controlador ${data.numero_controlador} ficará ${isOnline ? 'offline' : 'online'}`,
      type: 'question',
      showCancelButton: true,
      confirmButtonColor: isOnline ? '#ff7f07ff' : '#28a745',
      cancelButtonColor: '#6c757d',
      confirmButtonText: `Sim, ${acao}`,
      cancelButtonText: 'Cancelar',
      allowOutsideClick: false,
    }).then(result => {
      if (result.value) {
        this.props.toggleControladorStatus(data);
      }
    });
  };

  componentWillUnmount() {
    clearInterval(this.intervalGetList);
  }

  componentDidMount() {
    this.intervalGetList = setInterval(() => {
      this.props.getList();
    }, 5000);
  }

  changeMonitora(row, value) {
    alteraMonitora(row.numero_controlador, value === 'Sim' ? 1 : 0);
  }

  async downloadCroqui(croqui_file_id) {
    try {
      // O croqui_file_id já é apenas o nome do arquivo (ex.: croqui-1.pdf)
      const encodedCroquiFileId = encodeURIComponent(croqui_file_id);
      const response = await this.props.downloadCroqui(encodedCroquiFileId);

      if (response) {
        // Cria um URL temporário para o blob retornado pela API
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));

        // Cria um link temporário e o clica para iniciar o download
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', croqui_file_id); // O nome do arquivo já está correto
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        console.error('Erro ao baixar o arquivo');
      }
    } catch (error) {
      console.error('Erro ao baixar o arquivo:', error);
    }
  }

  render() {
    const contro = this.props.list || [];

    if (contro.length) {
      let listCont = [];
      const grupoFisicoId = configLocal.getConfig('grupo');
      const paginaAtual = this.props.paginaAtual;
      contro.forEach(cont => {
        if (parseInt(grupoFisicoId) === parseInt(cont.grupo_fisico_id)) {
          listCont.push(cont);
        }
      });

      const columns = [
        {
          Header: 'Ações',
          Cell: row => {
            const isOnline = row.original && row.original.ativo === 1;
            const isOffline = row.original && row.original.ativo === -1;
            return (
              <div className="actions-container">
                <PermissaoUsuario tela="CadControlador" condicao={true}>
                  <div className="action-group single-line-actions">
                    <ButtonTooltip
                      id="edit"
                      type="button"
                      className="warning btn-sm action-btn-tooltip"
                      icon="pencil-alt"
                      data-title="Alterar"
                      onClick={() => this.props.showUpdate(row.original)}
                    />
                    <ButtonTooltip
                      id="delete"
                      type="button"
                      className="danger btn-sm action-btn-tooltip"
                      icon="trash-alt"
                      data-title="Excluir"
                      onClick={() => this.removerControlador(row.original)}
                    />
                    <ToggleSwitch
                      isOn={isOnline}
                      onToggle={() => this.inativarControlador(row.original)}
                      size="small"
                      onColor="#28a745"
                      offColor="#6c757d"
                      className="toggle-switch-controlador"
                      title={isOnline ? 'Deixar offline' : 'Deixar online'}
                    />
                  </div>
                </PermissaoUsuario>
                <PermissaoUsuario tela="CadControlador" condicao={false}>
                  <div className="action-group single-line-actions">
                    <ButtonTooltip
                      id="edit"
                      type="button"
                      className="warning btn-sm action-btn-tooltip"
                      icon="pencil-alt"
                      data-title="Alterar"
                      onClick={() => this.props.showUpdate(row.original)}
                    />
                    <ButtonTooltip
                      id="delete"
                      type="button"
                      className="danger btn-sm action-btn-tooltip disabled"
                      icon="trash-alt"
                      data-title="Excluir"
                    />
                    <ToggleSwitch
                      isOn={false}
                      disabled={true}
                      size="small"
                      onColor="#28a745"
                      offColor="#6c757d"
                      className="toggle-switch-controlador"
                      title="Sem permissão"
                    />
                  </div>
                </PermissaoUsuario>
              </div>
            );
          },
          className: 'column_icon',
          width: 125,
          resizable: false,
          sortable: false,
          Filter: () => (
            <div className="rt-th">
              <span>Filtrar</span>
            </div>
          ),
        },
        {
          Header: 'Controlador',
          accessor: 'numero_controlador',
          minWidth: 100,
          maxWidth: 110,
          filterable: true,
          resizable: true,
          className: 'column_grid column_center',
          Cell: ({ value }) => value,
        },
        {
          Header: 'Anéis',
          accessor: 'total_anel',
          minWidth: 60,
          maxWidth: 80,
          className: 'column_grid column_center',
          filterable: true,
          resizable: true,
        },
        {
          Header: 'Endereço',
          accessor: 'endereco',
          minWidth: 220,
          className: 'column_grid column_left',
          filterable: true,
          resizable: true,
          filterMethod: (filter, row) => {
            if (!filter.value) return true;
            const cellValue = row[filter.id] ? row[filter.id].toString().toLowerCase() : '';
            const filterValue = filter.value.toLowerCase();
            return cellValue.includes(filterValue);
          },
        },
        {
          Header: 'Cruzamento',
          accessor: 'cruzamento',
          minWidth: 220,
          className: 'column_grid column_left',
          filterable: true,
          resizable: true,
          filterMethod: (filter, row) => {
            if (!filter.value) return true;
            const cellValue = row[filter.id] ? row[filter.id].toString().toLowerCase() : '';
            const filterValue = filter.value.toLowerCase();
            return cellValue.includes(filterValue);
          },
        },
        {
          Header: 'IP',
          accessor: 'ip',
          minWidth: 110,
          maxWidth: 120,
          className: 'column_grid',
          filterable: true,
          resizable: true,
          filterMethod: (filter, row) => {
            if (!filter.value) return true;
            const cellValue = row[filter.id] ? row[filter.id].toString().toLowerCase() : '';
            const filterValue = filter.value.toLowerCase();
            return cellValue.includes(filterValue);
          },
        },
        {
          Header: 'Porta',
          accessor: 'porta',
          minWidth: 60,
          maxWidth: 80,
          className: 'column_grid column_center',
          filterable: true,
          resizable: true,
        },
        {
          Header: 'Croqui',
          accessor: 'croqui_file_id',
          minWidth: 60,
          maxWidth: 80,
          className: 'column_grid column_center',
          filterable: false,
          resizable: true,
          Cell: ({ value }) =>
            value !== null ? (
              <Button onClick={() => this.downloadCroqui(value)} bsSize="xsmall">
                <i className={'fa fa-download'} />
              </Button>
            ) : null,
        },

        {
          Header: 'Monitorar',
          accessor: 'monitora_erro',
          minWidth: 100,
          maxWidth: 120,
          filterable: true,
          resizable: true,
          className: 'column_grid column_center',
          Cell: ({ value, row }) => {
            return (
              <select
                onChange={event => this.changeMonitora(row, event.target.value)}
                style={{ width: '100%' }}
                value={parseInt(value) === 1 ? 'Sim' : 'Não'}
                data-value={value}
              >
                <option value="Sim">Sim</option>
                <option value="Não">Não</option>
              </select>
            );
          },
          filterMethod: (filter, row) => {
            if (filter.value === 'Sim') {
              return parseInt(row[filter.id]) === 1;
            }
            if (filter.value === 'Não') {
              return parseInt(row[filter.id]) === 0;
            }
            if (filter.value === 'Todos') {
              return true;
            }
          },
          Filter: ({ filter, onChange }) => (
            <select
              onChange={event => onChange(event.target.value)}
              style={{ width: '100%' }}
              value={filter ? filter.value : 'Todos'}
            >
              <option value="Todos">Todos</option>
              <option value="Sim">Sim</option>
              <option value="Não">Não</option>
            </select>
          ),
        },
        {
          Header: 'Status',
          accessor: 'status_conexao',
          minWidth: 100,
          maxWidth: 120,
          filterable: true,
          resizable: true,
          className: 'column_grid column_center',
          Cell: ({ value, row }) => {
            // Os dados estão em row._original (ReactTable)
            const dadosControlador = row._original || row.original || row;
            const ativoValue = dadosControlador ? dadosControlador.ativo : null;

            // Se controlador está offline (ativo = -1), sempre mostrar "Offline"
            if (ativoValue === -1) {
              return <span className="connection-status offline">Offline</span>;
            }

            // Para todos os outros casos, usar lógica normal
            if (parseInt(row.monitora_erro) === 0) {
              return <span className="connection-status indeterminate">Indeterminado</span>;
            }
            return parseInt(value) <= 1 ? (
              <span className="connection-status connected">Conectado</span>
            ) : (
              <span className="connection-status disconnected">Sem Conexão</span>
            );
          },
          filterMethod: (filter, row) => {
            const dadosControlador = row._original || row.original || row;
            const ativoValue = dadosControlador ? dadosControlador.ativo : null;

            if (filter.value === 'Todos') {
              return true;
            }
            if (filter.value === 'Offline') {
              return ativoValue === -1;
            }
            if (filter.value === 'Indeterminado') {
              return parseInt(row.monitora_erro) === 0 && ativoValue !== -1;
            }
            if (filter.value === 'Conectado') {
              return parseInt(row[filter.id]) <= 1 && parseInt(row.monitora_erro) !== 0 && ativoValue !== -1;
            }
            if (filter.value === 'Sem Conexão') {
              return parseInt(row[filter.id]) > 1 && parseInt(row.monitora_erro) !== 0 && ativoValue !== -1;
            }
          },
          Filter: ({ filter, onChange }) => (
            <select
              onChange={event => onChange(event.target.value)}
              style={{ width: '100%' }}
              value={filter ? filter.value : 'Todos'}
            >
              <option value="Todos">Todos</option>
              <option value="Conectado">Conectado</option>
              <option value="Sem Conexão">Sem Conexão</option>
              <option value="Offline">Offline</option>
              <option value="Indeterminado">Indeterminado</option>
            </select>
          ),
        },
      ];

      return (
        <div className="controlador-list table-container" style={{ marginTop: '20px', width: '100%' }}>
          <style>{`
            .controlador-premium-table .ReactTable .rt-thead.-header {
              box-shadow: none;
            }

            .controlador-premium-table .ReactTable .rt-th.column_center,
            .controlador-premium-table .ReactTable .rt-td.column_center {
              justify-content: center;
              text-align: center;
            }

            .controlador-premium-table .ReactTable .rt-th.column_left,
            .controlador-premium-table .ReactTable .rt-td.column_left {
              justify-content: flex-start;
              text-align: left;
            }

            .controlador-premium-table .ReactTable .rt-th .rt-resizable-header-content,
            .controlador-premium-table .ReactTable .rt-th .rt-th-content {
              width: 100%;
              text-align: center;
              justify-content: center;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .controlador-premium-table .ReactTable .rt-td,
            .controlador-premium-table .ReactTable .rt-th {
              font-size: 12px;
            }

            .controlador-premium-table .ReactTable .rt-thead.-filters .rt-th {
              background: #ffffff;
              border-bottom: 1px solid #e2e8f0;
              padding: 8px;
              min-height: 52px;
            }

            .controlador-premium-table .ReactTable .rt-thead.-filters .rt-th input,
            .controlador-premium-table .ReactTable .rt-thead.-filters .rt-th select {
              width: 100%;
              min-width: 0;
              box-sizing: border-box;
              height: 32px;
              margin: 0;
              border: 1px solid #cbd5e1;
              border-radius: 10px;
              padding: 4px 10px;
              background: #ffffff;
              box-shadow: none;
            }

            .controlador-premium-table .ReactTable .rt-thead.-filters .rt-th select {
              padding-right: 28px;
            }

            .controlador-premium-table .ReactTable .rt-thead.-filters .rt-th:empty {
              padding: 0;
            }
          `}</style>

          <div className="controlador-premium-table">
            <PremiumTableShell hideToolbar tableMinWidth={1100}>
              <ReactTableGT2A
                data={listCont}
                columns={columns}
                className="-striped -highlight"
                defaultPageSize={20}
                showPagination
                filterable={true}
                onPageChange={this.handlePageChange}
                page={paginaAtual}
                style={{
                  fontSize: '13px',
                  width: '100%',
                }}
              />
            </PremiumTableShell>
          </div>
        </div>
      );
    }

    return <div />;
  }
}

const mapStateToProps = state => ({
  list: state.controladorCad.list,
  paginaAtual: state.controladorCad.paginaAtual,
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { downloadCroqui, showUpdate, remove, showSAP, getList, alteraMonitora, setPaginaAtual, toggleControladorStatus },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ControladorList);
